import styled from 'styled-components';
import Dialog from '@material-ui/core/Dialog';

export const StyledDialog = styled(Dialog)`
  .MuiDialog-paperScrollPaper {
    display: initial;
    background-color: #f8f8f8;
  }
`;
